export const SET_PRODUCT_DETAILS = "SET_PRODUCT_DETAILS";
export const RESET_PRODUCT_DETAIL = "RESET_PRODUCT_DETAIL";
export const GET_PDP_SIZE_CHART = "GET_PDP_SIZE_CHART";
export const HANDLE_SIZE_SELECTION = "HANDLE_SIZE_SELECTION";
